import React, { ReactNode } from "react";
import { SxProps } from "@mui/system";
import {
  ButtonGroup,
  IconButton,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
  Skeleton,
} from "@mui/material";
import {
  AddCircleOutlineOutlined,
  RemoveCircleOutlineOutlined,
} from "@mui/icons-material";
import { MobileTransferListItemSkeletonProps } from "components/lists/MobileTransferList";

interface ViolationListItemSkeletonProps
  extends MobileTransferListItemSkeletonProps {
  active: boolean;
  sx: SxProps;
  twoLine?: boolean;
}

const ViolationListItemSkeleton = ({
  active,
  sx,
  twoLine = false,
  included = active,
  readonly = false,
}: ViolationListItemSkeletonProps): ReactNode => {
  const isTablet = useMediaQuery(useTheme().breakpoints.only("sm"));
  return (
    <ListItem
      dense={!isTablet}
      sx={sx}
      divider={true}
      secondaryAction={
        <ButtonGroup disabled sx={{ px: 1 }}>
          {active ? (
            <IconButton size={"large"}>
              <RemoveCircleOutlineOutlined
                color={"disabled"}
                fontSize={"large"}
              />
            </IconButton>
          ) : (
            <IconButton>
              <AddCircleOutlineOutlined color={"disabled"} fontSize={"large"} />
            </IconButton>
          )}
        </ButtonGroup>
      }
    >
      <ListItemText
        sx={{ p: 0.5 }}
        primary={<Skeleton variant={"text"} width={200} />}
        primaryTypographyProps={{
          noWrap: true,
          variant: isTablet ? "h6" : "body2",
        }}
        secondary={
          twoLine ? <Skeleton variant={"text"} width={250} /> : undefined
        }
        secondaryTypographyProps={{ noWrap: true, variant: "subtitle2" }}
      />
    </ListItem>
  );
};

export default ViolationListItemSkeleton;
